// extracted by mini-css-extract-plugin
export default {"page":"dX-z","cartModal":"eX-z","checkout":"fX-z","placeholder":"gX-z","account":"hX-z"};